import { render } from "./MenuTabs.vue?vue&type=template&id=185813bc"
import script from "./MenuTabs.vue?vue&type=script&lang=js"
export * from "./MenuTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__